import mapboxgl from "mapbox-gl/dist/mapbox-gl-csp";

/**
 * CRA production builds break Mapbox's shared main/worker bundle
 * (ReferenceError: s is not defined when adding GeoJSON layers).
 * Use the CSP build with a separately served worker instead.
 */
const publicUrl = process.env.PUBLIC_URL || "";
mapboxgl.workerUrl = `${publicUrl}/mapbox-gl-csp-worker.js`;

export default mapboxgl;
